import React from 'react';
import styled from 'styled-components';
import {
  Flex,
} from 'chronos-styled';
import Button from '@atlaskit/button';
import ArrowRightIcon from '@atlaskit/icon/glyph/arrow-right';
import ArrowLeftIcon from '@atlaskit/icon/glyph/arrow-left';

import filters from 'chronos-assets/guide/chronos-filters.gif';
import datepicker from 'chronos-assets/guide/chronos-datepicker.gif';
import sidebar from 'chronos-assets/guide/chronos-sidebar.gif';
import daysSelecting from 'chronos-assets/guide/chronos-days-selecting.gif';
import timeline from 'chronos-assets/guide/chronos-timeline.gif';

const Overlay = styled(Flex)`
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  padding: 32px;
`;

const Text = styled.span`
  color: white;
  font-size: 1.5em;
  font-weight: 500;
  text-align: center;
`;

const Header = styled.span`
  color: white;
  font-size: 2em;
  font-weight: 800;
`;

class Guide extends React.Component {
  state = {
    step: 0,
  };

  stepToGifs = [
    filters,
    datepicker,
    sidebar,
    daysSelecting,
    timeline,
  ];

  titles = [
    'Filtering',
    'Date Picker',
    'Sidebar',
    'Selecting Days',
    'Timeline',
  ];

  copies = [
    'Narrow down the scope of JIRA worklogs using the Filters Popup. You can filter out worklogs by users, projects and etc.',
    'Choose the date range for your worklogs, use the week mode to get an overview of a week rather than full month',
    'Use sidebar to filter out worklogs even further. You can group-by sidebar items by Issue, Project, or User, and then select some items to narrow down worklogs in calendar',
    'Select days in calendar to calculate time worked only for specific dates. Use SHIFT key to select multiple days at once.',
    'Use the timeline if you prefer more spacious and informative overview of your worklogs',
  ]

  nextStep = () => this.setState(prevState => ({ step: prevState.step + 1 }));

  prevStep = () => this.setState(prevState => ({ step: prevState.step + 1 }));

  setStep = step => this.setState({ step });

  render() {
    const { step } = this.state;
    const { onFinish } = this.props;

    return (
      <Overlay column fillSpace spacing={16}>
        <Flex width="100%" justify="center">
          <Flex spacing={8} width="60%" align="center">
            <Header>
              Introduction to Chronos. {this.titles[step]}
            </Header>
          </Flex>
        </Flex>
        <Flex width="100%" justify="center">
          <img alt="gif" src={this.stepToGifs[step]} style={{ height: '60vh', objectFit: 'contain', background: 'white' }} width="60%" />
        </Flex>
        <Flex width="100%" justify="space-around" align="center">
          {step > 0 ? (
            <Button
              iconBefore={<ArrowLeftIcon />}
              onClick={() => this.prevStep()}
              appearance="primary"
            >
              Back
            </Button>
          ) : <div />}
          <Flex width="50%">
            <Text>
              {this.copies[step]}
            </Text>
          </Flex>
          {step < 3 ? (
            <Button
              iconAfter={<ArrowRightIcon />}
              onClick={() => {
                this.nextStep();
              }}
              appearance="primary"
              autoFocus
            >
              Next
            </Button>
          ) : (
            <Button
              onClick={() => {
                onFinish();
              }}
              appearance="primary"
              autoFocus
            >
              Finish
            </Button>
          )}
        </Flex>
      </Overlay>
    );
  }
}

export default Guide;
